import { Box } from "@mui/material";
import LoginForm from "../form/loginForm";

const SigninCard = ({ setcurrentTab }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexFlow: "column",
        paddingLeft: "32px",
        paddingRight: "32px",
        paddingTop: "32px",
        paddingBottom: "32px",
        background: "#FBFAFA",
        flexDirection: "column",
        borderRadius: "8px",
      }}
    >
      <LoginForm setcurrentTab={setcurrentTab} />
    </Box>
  );
};

export default SigninCard;
